// Resolution result card share event (MOR-227). Fires when a user shares
// the public, wallet-free market-resolution result card (the `market_result_public`
// ShareSurface) — the "answer revealed" hero that any spectator or participant
// can share at the resolution moment. Distinct from `market_result_shared`
// (the per-wallet personal-P&L card) and `share_clicked` (the generic market
// share).

import type { EventDefinition } from './navigation';
import type { PnlCardSharedMethod } from './pnl-card-shared';

export type ResolutionCardSharedProperties = {
  marketPubkey: string;
  method: PnlCardSharedMethod;
};

export const RESOLUTION_CARD_SHARED: EventDefinition<ResolutionCardSharedProperties> = {
  name: 'resolution_card_shared',
};
